import React from 'react';
import { Link } from 'gatsby';
import { Typography } from '@material-ui/core';

export interface CardTypeThreeProps {
  icon: any;
  heading: string;
  subHeading?: string;
  description: string;
}

const CardTypeThree = ({icon, heading, subHeading, description}) => {
  return (
    <div className="card-three-wrapper">
      <img src={icon} className="card-icon" />
      <Typography className="heading medium-font" component="h5">{heading}</Typography>
      {subHeading && <Typography className="sub-heading small-font" component="h6">{subHeading}</Typography>}
      <Typography className="description small-font" component="h5">{description}</Typography>
      <Link to="/contact-us" className="button small-font">Contact Sales</Link>
    </div>
  );
};


export default CardTypeThree;
